import { usePageRefreshKey } from '../../../../context/PageRefreshContext';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { getFlatTransferHistory } from '../../../../redux/actions/SocietyPortal/FlatTransferAction/FlatTransferAction';
import { selectedSocietyStorer } from '../../../../utils/webStorer';
import {
    SOCIETY_PORTAL,
    SOCIETY_PORTAL_FLAT_TRANSFER_DETAIL
} from '../../../../Routing/routes';

const statusColor = (s) => {
    switch (s) {
        case 'POSTED': return 'tw-bg-emerald-100 tw-text-emerald-700';
        case 'REVERSED': return 'tw-bg-amber-100 tw-text-amber-700';
        case 'DRAFT': return 'tw-bg-gray-100 tw-text-gray-700';
        default: return 'tw-bg-gray-100 tw-text-gray-700';
    }
};

const FlatTransferHistory = () => {
    const { flatId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const societyId = selectedSocietyStorer.getSocietyId();

    const { history } = useSelector(state => state.FlatTransferReducer);
    const [page, setPage] = useState(1);
    const limit = 10;

    const refreshKey = usePageRefreshKey();
    useEffect(() => {
        if (flatId) {
            dispatch(getFlatTransferHistory({ flatId, society_id: societyId, page, limit }));
        }
    }, [dispatch, flatId, societyId, page, refreshKey]);

    const rows = history?.rows || [];
    const pagination = history?.pagination;

    const goToDetail = (id) => {
        const path = SOCIETY_PORTAL_FLAT_TRANSFER_DETAIL.replace(':id', id);
        navigate(`${SOCIETY_PORTAL}${path}`);
    };

    return (
        <div className="tw-space-y-4">
            <div className="tw-flex tw-items-center tw-justify-between">
                <div className="tw-flex tw-items-center tw-gap-3">
                    <button onClick={() => navigate(-1)} className="tw-p-1.5 tw-rounded-md tw-border tw-border-gray-200 hover:tw-bg-gray-50">
                        <Icon icon="mdi:arrow-left" className="tw-text-gray-600" />
                    </button>
                    <div>
                        <h1 className="tw-text-lg tw-font-semibold tw-text-gray-800">Transfer History</h1>
                        <p className="tw-text-xs tw-text-gray-500">All ownership transfers for this flat</p>
                    </div>
                </div>
            </div>

            <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-100 tw-overflow-hidden">
                {history?.loading ? (
                    <div className="tw-py-10 tw-flex tw-justify-center">
                        <div className="tw-animate-spin tw-rounded-full tw-h-7 tw-w-7 tw-border-b-2 tw-border-blue-600" />
                    </div>
                ) : rows.length === 0 ? (
                    <div className="tw-py-10 tw-text-center">
                        <Icon icon="mdi:swap-horizontal" className="tw-text-3xl tw-text-gray-300" />
                        <p className="tw-text-sm tw-text-gray-500 tw-mt-2">No transfers found for this flat.</p>
                    </div>
                ) : (
                    <table className="tw-w-full tw-text-sm">
                        <thead>
                            <tr className="tw-bg-gray-50 tw-border-b tw-border-gray-100">
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Date</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">From</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">To</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Reason</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Settlement</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Status</th>
                                <th className="tw-text-center tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(row => {
                                const rowId = row.flat_transfer_id ?? row.id;
                                return (
                                <tr key={rowId} className="tw-border-b tw-border-gray-50 hover:tw-bg-gray-50">
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">{row.transfer_date}</td>
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">
                                        {row.oldEntity?.name || row.oldEntity?.first_name || '—'}
                                    </td>
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">
                                        {row.newEntity?.name || row.newEntity?.first_name || '—'}
                                    </td>
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">{row.transfer_reason}</td>
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">{row.balance_settlement_mode}</td>
                                    <td className="tw-px-3 tw-py-2">
                                        <span className={`tw-px-2 tw-py-0.5 tw-rounded tw-text-[10px] tw-font-medium ${statusColor(row.status)}`}>
                                            {row.status}
                                        </span>
                                    </td>
                                    <td className="tw-px-3 tw-py-2 tw-text-center">
                                        <button
                                            onClick={() => goToDetail(rowId)}
                                            className="tw-p-1.5 tw-rounded hover:tw-bg-blue-50 tw-text-gray-400 hover:tw-text-blue-600"
                                            title="View"
                                        >
                                            <Icon icon="mdi:eye-outline" />
                                        </button>
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>

            {!history?.loading && pagination && pagination.totalPages > 1 && (
                <div className="tw-flex tw-justify-center tw-gap-2">
                    <button
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        disabled={page === 1}
                        className="tw-px-3 tw-py-1.5 tw-text-sm tw-border tw-border-gray-200 tw-rounded-md disabled:tw-opacity-50"
                    >
                        Previous
                    </button>
                    <span className="tw-px-3 tw-py-1.5 tw-text-sm">
                        Page {pagination.page} of {pagination.totalPages}
                    </span>
                    <button
                        onClick={() => setPage(p => Math.min(pagination.totalPages, p + 1))}
                        disabled={page === pagination.totalPages}
                        className="tw-px-3 tw-py-1.5 tw-text-sm tw-border tw-border-gray-200 tw-rounded-md disabled:tw-opacity-50"
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default FlatTransferHistory;
